// libs/api/verification.js

import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

/**
 * Ambil data verifikasi PKS berdasarkan PKS ID
 * GET /pks/:pksId/verification
 */
export async function getVerification(
  pathname,
  queryParams = "",
  extraHeaders = {},
) {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams, {
    headers: extraHeaders,
  });
}

/**
 * Submit aksi verifikasi (approve / reject / request_revision)
 * POST /pks/:pksId/verification/:stage/action
 * body: { action, comment, item_comments }
 */
export async function submitVerification(pathname, body) {
  return await instance({ baseURL: baseURL }).post(pathname, body);
}

/**
 * Ambil riwayat log verifikasi
 * GET /pks/:pksId/verification/logs
 */
export const getVerificationLogs = (pathname, queryParams, headers) =>
  instance.get(pathname, { params: queryParams, headers });

/**
 * Assign verifikator ke sebuah stage
 * POST /pks/:pksId/verification/:stage/assign
 */
export const assignVerificator = (pathname, body) =>
  instance.post(pathname, body);

/**
 * Batalkan / reset verifikasi stage tertentu (admin only)
 * DELETE /pks/:pksId/verification/:stage
 */
export const resetVerificationStage = (pathname) => instance.delete(pathname);

/**
 * Generate invoice setelah semua verifikasi approved
 * POST /pks/:pksId/generate-invoice
 */
export async function generateInvoice(pathname, body = {}) {
  return await instance({ baseURL: baseURL }).post(pathname, body);
}
